var crypto = require('crypto')
var assert = require('nanoassert')
var dh = require('./dh')

var HASHLEN = 32
var BLOCKLEN = 64

module.exports = {
  HASHLEN,
  BLOCKLEN,
  hash,
  hkdf
}

function hash(data) {
  const hash = crypto.createHash('sha256');
  hash.update(data)
  return hash.digest()
}

function hmac(key, data) {
  var hmac = crypto.createHmac('sha256', key)
  hmac.update(data)
  return hmac.digest()
}

function hkdf(chainingKey, inputKeyMaterial, numOutputs) {
  assert(chainingKey.length === HASHLEN)
  assert(numOutputs === 2 || numOutputs === 3)
  assert([0, 32, dh.DHLEN].includes(inputKeyMaterial.length))

  var tempKey = hmac(chainingKey, inputKeyMaterial)
  var output1 = hmac(tempKey, Buffer.from([0x01]))
  var output2 = hmac(tempKey, Buffer.concat([output1, Buffer.from([0x02])]))
  if (numOutputs == 2) {
    return [output1, output2]
  }
  var output3 = hmac(tempKey, Buffer.concat([output2, Buffer.from([0x03])]))
  return [output1, output2, output3]
}
